import { Directive, Input, ElementRef, Renderer2 } from "@angular/core";

@Directive({
    selector: "mat-slide-toggle[dodo-toggle]",
    standalone: false
})
export class DodoToggleDirective {
	private __element: HTMLElement;

	@Input() busy: boolean;

	constructor(er: ElementRef, __renderer: Renderer2) {
		const __element = er.nativeElement;
		__renderer.addClass(__element, "dodo-toggle");
	}
}
